@if (search().show) {
	<app-search
		[disabled]="disabled()"
		[placeholder]="search()?.options?.placeholder"
		(searchUpdated)="searchUpdated.emit($event)"
	></app-search>
}

<div class="flex flex-col flex-wrap z-50 h-auto">
	@if (checkboxesForm) {
		<div class="flex flex-col flex-wrap">
			<form
				[formGroup]="checkboxesForm"
				class="text-xs w-full"
				[class.form-container]="constrainScrollHeight()"
				[class.lg:h-[300px]]="constrainScrollHeight()"
				[class.overflow-y-auto]="constrainScrollHeight()"
				[class.overflow-x-hidden]="constrainScrollHeight()"
			>
				@if (options().length) {
					@if (showCheckAll()) {
						<div class="w-3/4 lg:w-full overflow-hidden">
							@let togglingCheckboxes = toggleAllCheckbox$ | async;
							<mat-checkbox
								class="text-mainColor"
								#toggleAllCheckbox
								[checked]="togglingCheckboxes === CheckboxSelected.ALL"
								[disabled]="disabled()"
								[indeterminate]="togglingCheckboxes === CheckboxSelected.SOME"
								(change)="toggleAll($event.checked)"
							>
								{{ toggleAllCheckbox.checked ? 'Odznacz wszystko' : 'Zaznacz wszystko' }}
							</mat-checkbox>
						</div>
					}
				} @else {
					<p class="h-full flex justify-center items-center text-xl text-mainColor">Brak wyników</p>
				}
				<div class="w-3/4 lg:w-full overflow-hidden flex flex-col">
					@for (option of visibleOptions(); track option.id) {
						<mat-checkbox [disabled]="disabled()" [formControlName]="option.id" class="text-mainColor">
							{{ option.name }}
						</mat-checkbox>
					}
				</div>
			</form>
			@if (hasMoreOptions()) {
				<button
					type="button"
					class="mt-2 w-full text-center text-sm font-medium text-mainColor transition hover:text-accentColor"
					(click)="showMore()"
				>
					Pokaż więcej <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
				</button>
			}
		</div>
	}
</div>
